export default __webpack_public_path__ + "static/media/(3).b7dfb139.jpeg";